import ApiCaller from "./apiCaller";

export const getWards = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse("ward/by_boundary", mapBoundary);

export const getDistricts = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse("district/by_boundary", mapBoundary);

export const getExternalFoodAndBeverageCategoriesByRadius = (radiusData: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_radius/category",
    radiusData
  );

export const getExternalFoodAndBeverageCategories = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_boundary/category",
    mapBoundary
  );

export const getExternalFoodAndBeverageDataByRadius = (radiusData: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_radius",
    radiusData
  );

export const getExternalFoodAndBeverageData = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_boundary",
    mapBoundary
  );

export const getExternalFoodAndBeverageDeliveryDataByRadius = (
  radiusData: any
) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_delivery_data/by_radius",
    radiusData
  );

export const getExternalFoodAndBeverageDeliveryData = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_delivery_data/by_boundary",
    mapBoundary
  );

export const getStaticDemandDataByRadius = (radiusData: any) =>
  ApiCaller.postWithLatestResponse(
    "external_static_demand_data/by_radius",
    radiusData
  );

export const getStaticDemandData = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_static_demand_data/by_boundary",
    mapBoundary
  );

export const getNearbyLocationSummary = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "location/by_boundary/group_by/location_type",
    mapBoundary
  );

export const getNearbyLocationDetail = (
  mapBoundary: any,
  filter: Array<any>
) => {
  if (filter.length == 0) {
    return Promise.resolve({
      result: {
        locations: [],
      },
      status: "ok",
      statusCode: 200,
    });
  }
  return ApiCaller.postWithLatestResponse("new_location/by_boundary/list", {
    ...mapBoundary,
    filters: filter,
  });
};

export const getSitePlanningPolygon = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "site_planning_selection_area/list?limit=10000",
    mapBoundary
  );

export const getExternalRetailData = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_retail_data/by_boundary",
    mapBoundary
  );

export const getWardsDemographics = (wards: Array<any>) => {
  const wardIds = wards.map((ward: any) => ward.id) || [];
  const requestBody = {
    wards: wardIds,
  };
  return ApiCaller.postWithLatestResponse("ward/demographics", requestBody);
};

export const brandLocationType = (id: number) => {
  return ApiCaller.getWithLatestResponse(
    `brand_location_type/?q=(filters:!((col:is_active,opr:eq,value:1),(col:location_type,opr:rel_o_m,value:${id})))`
  );
};

export const getDataMap = (mapBoundary: any, filter: Array<any>) => {
  return Promise.all([
    getWards(mapBoundary),
    getExternalFoodAndBeverageCategories(mapBoundary),
    getExternalFoodAndBeverageData(mapBoundary),
    getExternalFoodAndBeverageDeliveryData(mapBoundary),
    getStaticDemandData(mapBoundary),
    getNearbyLocationSummary(mapBoundary),
    getNearbyLocationDetail(mapBoundary, filter),
    getSitePlanningPolygon(mapBoundary),
    getExternalRetailData(mapBoundary),
  ]);
};

export const getExternalFoodAndBeverageDeliveryListByRadius = (
  radiusData: any
) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_delivery_data/by_radius/list",
    radiusData
  );

export const getExternalFoodAndBeverageDeliveryList = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_delivery_data/by_boundary/list",
    mapBoundary
  );

export const getExternalFoodAndBeverageListByRadius = (radiusData: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_radius/list",
    radiusData
  );

export const getExternalFoodAndBeverageList = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_food_and_beverage_data/by_boundary/list",
    mapBoundary
  );

export const getStaticListByRadius = (radiusData: any) =>
  ApiCaller.postWithLatestResponse(
    "external_static_demand_data/by_radius/list",
    radiusData
  );

export const getStaticList = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_static_demand_data/by_boundary/list",
    mapBoundary
  );

export const getRetailList = (mapBoundary: any) =>
  ApiCaller.postWithLatestResponse(
    "external_retail_data/by_boundary/list",
    mapBoundary
  );
